<template>
  <div class="broadcast">
    <div class="broadcast__inner">
      <div class="broadcast__icon" :class="{ 'broadcast__icon--idle': isEmpty }">
        <template v-if="!isEmpty">
          <div class="broadcast__icon-halo"></div>
          <div class="broadcast__icon-pulse"></div>
        </template>
        <i class="icon-loding-ai-line t-iconfont"></i>
      </div>
      <div class="broadcast__content">
        <template v-if="isEmpty">
          <div class="broadcast__text">AI 随时准备为你工作</div>
        </template>
        <template v-else>
          <van-swipe :autoplay="2000" :show-indicators="false" style="height: 20px" vertical>
            <template v-for="(item, index) in swipeData" :key="index">
              <van-swipe-item>
                <div class="broadcast__text">
                  <span class="broadcast__text-prefix">{{ item.firstMessage }}【</span>
                  <span class="broadcast__text-main">{{ item.secondMessage }}</span>
                  <span class="broadcast__text-suffix">】{{ item.thirdMessage }}</span>
                </div>
              </van-swipe-item>
            </template>
          </van-swipe>
        </template>
      </div>
      <div class="broadcast__action" @click="handleView">
        {{ isEmpty ? '查看 AI 工作明细' : '查看' }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  swipeData: {
    type: Array,
    default: () => []
  }
})

const emits = defineEmits(['openWrokDetail'])

const isEmpty = computed(() => props.swipeData.length === 0)

const handleView = () => {
  emits('openWrokDetail')
}
</script>

<style lang="scss" scoped>
.broadcast {
  display: flex;
  align-items: center;
  border-radius: 12px;
  background: linear-gradient(
    277deg,
    rgba(21, 116, 255, 0.15) 2%,
    rgba(89, 82, 255, 0.15) 51%,
    rgba(169, 105, 254, 0.15) 96%
  );
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  padding: 1px;

  &__inner {
    flex: 1;
    border-radius: 12px;
    background: #fff;
    padding: 12px 16px;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
  }

  &__icon {
    flex: 0 0 auto;
    margin-right: 8px;
    position: relative;
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      font-size: 18px;
      background: linear-gradient(315deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    &--idle i {
      background: none;
      -webkit-text-fill-color: #969799;
      color: #969799;
    }
  }

  &__icon-halo {
    position: absolute;
    inset: -10px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(110, 100, 220, 0.12) 0%, transparent 70%);
    animation: broadcast-breathe-halo 3.6s ease-in-out infinite;
  }

  &__icon-pulse {
    position: absolute;
    inset: -6px;
    border-radius: 50%;
    border: 1px solid rgba(110, 100, 220, 0.2);
    animation: broadcast-breathe-ring 3.6s ease-in-out infinite;
  }

  &__content {
    flex: 1;
    overflow: hidden;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #646566;
  }

  &__text {
    display: flex;
    overflow: hidden;
  }

  &__text-prefix,
  &__text-suffix {
    flex: 0 0 auto;
  }

  &__text-main {
    flex: 0 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__action {
    margin-left: 12px;
    flex: 0 0 auto;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #7a52f4;
    cursor: pointer;
  }
}

@keyframes broadcast-breathe-halo {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(0.92);
  }
  50% {
    opacity: 1;
    transform: scale(1.08);
  }
}

@keyframes broadcast-breathe-ring {
  0%,
  100% {
    opacity: 0.25;
    transform: scale(0.94);
  }
  50% {
    opacity: 1;
    transform: scale(1.06);
  }
}
</style>
